import React from "react"
import "./index.scss"

const RecordScreen = ({ tooltip, onClick }) => (
  <div className="record-wrapper">
    <div className="record" data-tip={tooltip} onClick={onClick} />
  </div>
)

export default RecordScreen
